import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';
import weekdayPlugin from 'dayjs/plugin/weekday';

dayjs.extend(utcPlugin);
dayjs.extend(isBetweenPlugin);
dayjs.extend(timezone);
dayjs.extend(weekdayPlugin);
dayjs.extend(localizedFormat);
